<template>
      <list
            :columns="columns"
            :modalCreate="modalCreate"
            :removeLink="removeLink"
            :cardLink="cardLink"
            :isUpdate="true"
            :isAdd="true"
            :itemLink="itemLink"
            :setLink="setLink"
            :openItem="false"
            :fields="fields"
            :searchDisable="true"
            @change="change"
            @changeFunction="changeFunction"
            v-model="val"
      />
</template>
<script>
export default {
  name: "products",
  props:['id'],
  created(){
    this.itemLink = `business/clients/${this.id}/guardians`;
    this.setLink = `business/clients/${this.id}/guardians`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  
  },
  data() {
    return {
      val: [],
      modalCreate: "client_group",
      fields: [
          {
              col:'col-12 col-md-6',
              label: "Выберите родителя",
              key: "guardian",
              type: "select",
              selectKey: "full_name",
              modal: "guardian",
              prefix: "client_guardian",
          },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_group",
      itemLink: "",
      setLink: "",
      columns: [
          {
            key: "full_name",
            title: "ФИО",
            checkbox: false,
          },
          {
              key: "phone",
              title: "Номер телефона",
              checkbox: false,
              control: false,
              align: "left",
              timer: false,
              detail: false,
          },
          {
              detail: false,
              remove: true,
          },
      ],
    };
  },
};
</script>
<style>
</style>
